import { FC, memo } from 'react'

import { FF, FormType, TextInput, Validators } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { MetrcFormPayload } from '../types'

import * as SC from './styles'

type Props = {
  form: FormType<MetrcFormPayload>
}

export const MetrcForm: FC<Props> = memo((props) => {
  const { form } = props

  return (
    <>
      <SC.Title>Please Add Metrc Key</SC.Title>
      <SC.Note>One Metrc key may work for multiple licenses</SC.Note>
      <FormRow>
        <Col>
          <form.Field
            name="key"
            validators={{
              onSubmit: ({ value }) => Validators.required.field(value)
            }}
            children={(field) => (
              <FF label="Metrc Key" field={field} required input={(inputProps) => <TextInput {...inputProps} />} />
            )}
          />
        </Col>
      </FormRow>
    </>
  )
})
